jQuery(document).ready(function ($) {
  $('.review-slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0937/1880/6813/files/Group_245.png?v=1746174858"></div>',
    nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0937/1880/6813/files/Group_244.png?v=1746174835"></div>',
    responsive: [
      {
        breakpoint: 992, // targets max-width: 991px
        settings: {
          arrows: false, // disable arrows on tablets
          dots: true     // enable dots on tablets
        }
      }
    ]
  });

  var $slider = $('.home_product_slider');

  $slider.on('init', function (event, slick) {
    updateProgress(slick, 0); // initialize progress
  });

  $slider.on('afterChange', function (event, slick, currentSlide) {
    updateProgress(slick, currentSlide);
  });

  $slider.slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0937/1880/6813/files/Group_37.png?v=1746184086"></div>',
    nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0937/1880/6813/files/Group_38.png?v=1746184072"></div>',
    responsive: [
      {
        breakpoint: 992, // targets max-width: 991px
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768, // targets max-width: 991px
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  function updateProgress(slick, currentSlide) {
    var slidesToShow = slick.options.slidesToShow;
    console.log(slidesToShow);
    var totalSlides = slick.slideCount;
    console.log(totalSlides);
    var totalPages = Math.ceil(totalSlides - slidesToShow) + 1;
    console.log(totalPages);
    var currentPage = Math.floor(currentSlide / 1) + 1;
    console.log(currentPage);

    var percentage = (currentPage / totalPages) * 100;

    $('#slick-slide-counter').text(currentPage + '/' + totalPages);
    $('#slick-progress-bar').css('width', percentage + '%');
  }


});
